import React from 'react'

const NoResults = ({ text }) => (
  <div className='studytestmain_noResults'>
    {text || 'Пока нет ни одного результата'}
  </div>
)

export default NoResults
